import { render, staticRenderFns } from "./readSms.vue?vue&type=template&id=05b725c5&"
import script from "./readSms.vue?vue&type=script&lang=js&"
export * from "./readSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports